"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = _default;

var _color = _interopRequireDefault(require("color"));

var _arrow_left = _interopRequireDefault(require("../img/arrow_left.svg"));

var _arrow_right = _interopRequireDefault(require("../img/arrow_right.svg"));

var _double_right = _interopRequireDefault(require("../img/double_right.svg"));

var _double_left = _interopRequireDefault(require("../img/double_left.svg"));

function _default(palette) {
  return {
    background: palette.elPrimary,
    borderColor: palette.elPrimary,
    color: palette.tFilled,
    boxShadow: "0 6px 10px 0 ".concat(palette.elShadow, ", 0 4px 10px 0 ").concat(palette.elShadow),
    zIndex: palette.zOverlay,
    weekColor: palette.tInactive,
    headFontSize: palette.tsNormal,
    headLineHeight: palette.tlNormal,
    monthDecreaseIcon: _arrow_left["default"],
    monthIncreaseIcon: _arrow_right["default"],
    yearIncreaseIcon: _double_right["default"],
    yearDecreaseIcon: _double_left["default"],
    dateColor: palette.tFilled,
    dateFontSize: palette.tsSmall,
    dateLineHeight: palette.tlSmall,
    dateBackground: 'transparent',
    dateColorHover: palette.tActive,
    dateBackgroundHover: palette.elLightest,
    dateColorActive: palette.tInversion,
    dateBackgroundActive: palette.elAccent,
    dateTodayColor: palette.tAccent,
    dateTodayBackground: 'transparent',
    dateDisabledColor: palette.tDisabled,
    dateDisabledBackground: 'transparent',
    dateSelectedColor: palette.tInversion,
    dateSelectedBackground: palette.elAccent,
    periodBackground: (0, _color["default"])(palette.elAccent).alpha(0.25).string()
  };
}